import React from 'react';

const SITE_URL = 'https://www.cizlot.com';

const Seo = ({ title, description, keywords, path = '/', noindex = false }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    {noindex && <meta name="robots" content="noindex, nofollow" />}
  </>
);

export default Seo;
